import { render, staticRenderFns } from "./ProductComment.vue?vue&type=template&id=2a6880b2&"
import script from "./ProductComment.vue?vue&type=script&lang=js&"
export * from "./ProductComment.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/product/ProductComment/ProductCommentStylePublic.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports